import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { convertTextToNativeEmojis } from './emoji.utils';

/**
 * Converts raw emoji id to native emojis.
 *
 * Usage: `{{ ':) my text' | emoji }}`
 * Output: `😊 my text`
 */
@Pipe({ standalone: true, name: 'emoji' })
export class EmojiPipe implements PipeTransform {
  transform(text?: string): string | undefined {
    if (!text) {
      return text;
    }
    return convertTextToNativeEmojis(text);
  }
}
